import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaGoogle, FaFacebook } from 'react-icons/fa';
import { auth, db } from '../Config/firebase';
import { signInWithEmailAndPassword, GoogleAuthProvider, FacebookAuthProvider, signInWithPopup } from 'firebase/auth';
import { ref, get } from 'firebase/database';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import { useUser } from '../Contexts/UserContext';
import Modal from '../Components/Modal';
import { handleSocialAuth } from '../Components/socialAuthHandler';

const SignInPage = () => {
  const navigate = useNavigate();
  const { setUser } = useUser();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleEmailSignIn = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setErrorMessage('Email and password are required.');
      setShowModal(true);
      return;
    }

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const userSnapshot = await get(ref(db, 'users/' + user.uid));
      const userData = userSnapshot.val();

      if (userData) {
        setUser({ uid: user.uid, email: user.email, username: userData.username });
        navigate('/');
      } else {
        setErrorMessage('No user data found.');
        setShowModal(true);
      }
    } catch (error) {
      console.error('Error:', error);
      setErrorMessage(error.message);
      setShowModal(true);
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const userData = await handleSocialAuth(result.user, db, 'google');
      setUser(userData);
      navigate('/');
    } catch (error) {
      console.error('Error:', error);
      setErrorMessage(error.message);
      setShowModal(true);
    }
  };

  const handleFacebookSignIn = async () => {
    try {
      const provider = new FacebookAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const userData = await handleSocialAuth(result.user, db, 'facebook');
      setUser(userData);
      navigate('/');
    } catch (error) {
      console.error('Error:', error);
      setErrorMessage(error.message);
      setShowModal(true);
    }
  };

  return (
    <div>
      <Navbar />
      <section className="min-h-screen bg-white flex items-center pt-24 pb-16">
        <div className="container mx-auto text-center px-4">
          <div className="max-w-2xl mx-auto">
            <h1 className="text-6xl font-medium text-gray-800 mb-8 font-trends">Sign In</h1>
            
            <form onSubmit={handleEmailSignIn} className="w-full max-w-sm mx-auto text-left mb-8">
              <div className="mb-6">
                <label className="block text-gray-600 mb-2">Email</label>
                <input 
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-[#E57373]"
                />
              </div>
              <div className="mb-6">
                <label className="block text-gray-600 mb-2">Password</label>
                <input 
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-[#E57373]"
                />
              </div>
              <button type="submit" className="bg-[#E57373] hover:bg-[#EF9A9A] text-white rounded-full px-8 py-3 text-lg w-full">
                Sign In
              </button>
            </form>

            <div className="mt-6">
              <p className="text-gray-600">Or sign in with:</p>
              <div className="flex justify-center space-x-4 mt-4">
                <button
                  onClick={handleGoogleSignIn}
                  className="bg-white border border-gray-300 rounded-full px-6 py-2 shadow-sm hover:shadow-md transition duration-200 flex items-center"
                >
                  <FaGoogle className="w-5 h-5 mr-2 text-red-600" />
                  Google
                </button>
                <button
                  onClick={handleFacebookSignIn}
                  className="bg-white border border-gray-300 rounded-full px-6 py-2 shadow-sm hover:shadow-md transition duration-200 flex items-center"
                >
                  <FaFacebook className="w-5 h-5 mr-2 text-blue-600" />
                  Facebook
                </button>
              </div>
            </div>

            <p className="mt-6 text-gray-600">
              Don't have an account? <Link to="/signup" className="text-[#E57373] underline">Sign Up</Link>
            </p>
          </div>
        </div>
      </section>
      <Modal 
        show={showModal} 
        message={errorMessage} 
        onClose={() => setShowModal(false)} 
      />
      <Footer />
    </div>
  );
};

export default SignInPage;